import { render } from "./DrawUpdateModal.vue?vue&type=template&id=1e6113f2&ts=true"
import script from "./DrawUpdateModal.vue?vue&type=script&lang=ts"
export * from "./DrawUpdateModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__